<div class="row g-2">
    <div class="col-7">
        <!--
            The halves carry the errors so the invalid outline marks both, but print none: the
            message belongs to the instant, and is printed once below.
        -->
        <pace-date-field
            [value]="parts().date"
            (valueChange)="setDate($event)"
            [errors]="errors()"
            [showErrorMessages]="false"
            [disabled]="disabled()"
            [readonly]="readonly()"
            [required]="required()"
            [minDate]="minDate()"
            [maxDate]="maxDate()"
            [ariaLabel]="dateAriaLabel()"
            (touchedChange)="touched.set(true)"
        ></pace-date-field>
    </div>
    <div class="col-5">
        <pace-time-field
            [value]="parts().time"
            (valueChange)="setTime($event)"
            [errors]="errors()"
            [showErrorMessages]="false"
            [disabled]="disabled()"
            [readonly]="readonly()"
            [required]="required()"
            [ariaLabel]="timeAriaLabel()"
            (touchedChange)="touched.set(true)"
        ></pace-time-field>
    </div>
</div>
@if (hasErrorMessages()) {
    <div class="invalid-feedback d-block">
        @for (error of errors(); track error.kind) {
            <div>{{ error.message ?? error.kind }}</div>
        }
    </div>
}
